/**
 * Хүргэлтийн бүсийн шалгалтад ppadmin-ий `out-off-zone` руу ямар query явуулахыг шийднэ.
 *
 * Эндпойнт хоёр режимтэй бөгөөд таб тус бүрд өөр эх сурвалж тохирно:
 *  - `addressMap`    — мерчант зурган дээр сонгосон ЯГ ТЭР координат. Хаягийн текстээр
 *                      дахин geocode хийхгүй тул хамгийн зөв, Mezorn руу ч дуудахгүй.
 *  - `addressDetail` — гараас бичсэн дэлгэрэнгүй хаяг + баг/хорооны бүтэн код (аймаг, сум,
 *                      хороог агуулсан). Дотоод (хуучин) кодоор явуулна — шинэ код болгох
 *                      хувиргалтыг backend хийдэг (`getNearbyAddress`, `addressingList`-тэй ижил конвенц).
 */

/**
 * Газрын зураг дээр үнэхээр хаяг сонгосон эсэх.
 * `selectedDeliveryAddress` нь контекстэд УБ-ын төвөөр (зөвхөн `location`-той) инициалцдаг тул
 * `location` байгаа эсэхээр шалгаж болохгүй — сонгосон хаягт л `addressId` байдаг.
 */
const hasPickedOnMap = (address) => Boolean(address?.addressId);

/** Query байгуулна. Шалгах хэмжээний өгөгдөл бүрдээгүй бол `null` (дуудахгүй). */
export const buildZoneQuery = ({
  selectedTab,
  selectedDeliveryAddress,
  deliveryDetail,
  khorooId,
}) => {
  if (selectedTab === 'addressMap') {
    if (!hasPickedOnMap(selectedDeliveryAddress)) return null;

    const { lat, lon } = selectedDeliveryAddress.location ?? {};
    if (lat == null || lon == null) return null;

    return { lat, lon };
  }

  const addressText = deliveryDetail?.trim();
  if (!addressText || !khorooId) return null;

  return { addressText, regionId: khorooId };
};

/** Хүргэлтийн бүсээс хэтэрсэн 1 км тутмын нэмэлт төлбөр (₮) */
export const OUT_OF_ZONE_PRICE_PER_KM = 2000;

/**
 * Бүсээс хэтэрсэн зайн нэмэлт төлбөр.
 *
 * Backend-ийн үнэ бодолтод ОРООГҮЙ: `out-off-zone`-оос ирсэн зайг front талдаа
 * км тутам `OUT_OF_ZONE_PRICE_PER_KM`-аар үржүүлж зөвхөн ХАРУУЛАХ зорилгоор тооцно
 * (бутархай км нь тэр хэвээрээ — 2.74 км → 5,480₮).
 *
 * @param zoneData `useOutOfZone`-ийн `data` — `{ isOutOfZone, distanceKm }`.
 * @returns Нэмэлт төлбөр. Бүсэд байгаа/зай нь ирээгүй/шалгалт амжаагүй бол `0`.
 */
export const calcOutOfZoneFee = (zoneData) => {
  if (!zoneData?.isOutOfZone) return 0;

  const distanceKm = Number(zoneData.distanceKm);
  if (!Number.isFinite(distanceKm) || distanceKm <= 0) return 0;

  return Math.round(distanceKm * OUT_OF_ZONE_PRICE_PER_KM);
};
